module.exports = __webpack_public_path__ + "static/media/about_pic_mess3.45fee835.jpg";